// #POW-100
import { useContext, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import DashboardLayout from "../layouts/DashboardLayout";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next"; // #POW-29
import useCustomFetch from '../hooks/useCustomFetch';  // #POW-30
import { useNavigate } from "react-router-dom";
import ExportArchiveDataGrid from "../components/ExportArchiveDataGrid";

const ExportArchivePage = () => {
  const { t } = useTranslation();  // #POW-29
  const customFetch = useCustomFetch(); // #POW-30
  const auth = useContext(AuthContext)
  const navigate = useNavigate();
  
  const { isReady } = useContext(AuthContext)
  
  useEffect(() => {
    if (isReady) {
      if (!auth.canAccessContext('pages.AllTransactionsPage')) { // #POW-22 
        navigate("/dashboard");
      }
    }
  }, [isReady]);

  
  return (
    <>
    <DashboardLayout>
      <Typography component="h1" sx={{textAlign:'left', width:'100%', typography: { xs: 'h5', sm: 'h4' }}}>
        {t('exportArchive.title')}
      </Typography>
      <Stack direction="row" sx={{justifyContent: "space-between", alignItems: "center", width: '100%'}}>
        
      </Stack>
      <ExportArchiveDataGrid />
    </DashboardLayout>
  </>
  );
};

export default ExportArchivePage;
